import { Roles } from '../utils/enums/Roles';

export const adminDashboardAuthorizedRoles = [
	Roles.SysAdmin,
	Roles.TenantAdmin,
	Roles.Authorizer,
];
